module.exports = __webpack_public_path__ + "static/media/10import-23.451852c6.xlsx";